import React from 'react';
import { Bar } from 'react-chartjs-2';

const BarMonthsStats = ({ statistics }) => {
    // Données des mois pour les labels
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

    // Couleurs
    const colors = [
        'rgba(0, 0, 143, 0.6)',    // AXA Blue 400 avec opacité 0.6
        'rgba(210, 71, 35, 0.6)',   // Sienna 400 avec opacité 0.6
        'rgba(19, 134, 54, 0.6)',   // Success Green avec opacité 0.6
        'rgba(201, 20, 50, 0.6)',   // Danger Red avec opacité 0.6
        'rgba(255, 188, 17, 0.6)',  // Warning Yellow avec opacité 0.6
        'rgba(73, 118, 186, 0.6)',  // Info Ocean 200 avec opacité 0.6
        'rgba(138, 115, 51, 0.6)',  // Apache 200 avec opacité 0.6
        'rgba(91, 123, 115, 0.6)',  // Viridian 200 avec opacité 0.6
        'rgba(2, 113, 128, 0.6)',   // Teal 200 avec opacité 0.6
        'rgba(145, 65, 70, 0.6)',   // Tosca 200 avec opacité 0.6
        'rgba(255, 127, 80, 0.6)',  // Corail avec opacité 0.6
        'rgba(147, 112, 219, 0.6)'  // Violet clair avec opacité 0.6
    ];

    // Trier les données par année et par mois
    const sortedData = statistics.contrats_par_mois.sort((a, b) => {
        if (a.annee === b.annee) {
            return a.mois - b.mois;  // Trie par mois si même année
        }
        return a.annee - b.annee;  // Trie par année
    });

    const chartData = {
        labels: sortedData.map(item => `${months[item.mois - 1]} ${item.annee}`), // Utilise les noms des mois + année
        datasets: [
            {
                data: sortedData.map(item => item.nombre_contrats),
                backgroundColor: sortedData.map((_, index) => colors[index % colors.length]), // Couleurs avec opacité
                borderColor: sortedData.map((_, index) => colors[index % colors.length].replace('0.6', '1')), // Bordures pleines (100% opacité)
                borderWidth: 1,
            },
        ],
    };

    // Options du graphique
    const chartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                display: false,  // Désactive complètement la légende
            },
        },
        scales: {
            y: {
                beginAtZero: true,
                ticks: {
                    callback: function (value) {
                        return Number.isInteger(value) ? value : null; // Affiche seulement les entiers
                    },
                    stepSize: 1,
                    color: '#00000F', // AXA Blue for Y-axis labels
                    font: {
                        size: 14,
                        weight: 'bold',
                    },
                },
                title: {
                    display: true,
                    text: 'Nombre de contrats',
                    color: '#00008F', // AXA Sienna for axis title
                    font: {
                        size: 16,
                        weight: 'bold',
                    },
                },
            },
            x: {
                ticks: {
                    color: '#00000F', // AXA Blue for X-axis labels
                    font: {
                        size: 14,
                        weight: 'bold',
                    },
                },
                title: {
                    display: true,
                    text: 'Mois',
                    color: '#00008F', // AXA Sienna for axis title
                    font: {
                        size: 16,
                        weight: 'bold',
                    },
                },
            },
        },
    };

    return (
        <div className="bg-white p-8 rounded-lg shadow-lg lg:col-span-2 h-auto overflow-auto">
            <h2 className="text-2xl font-bold mb-6 text-center text-axa-blue-400">Contrats par Mois</h2>
            <div className="relative w-full h-72">
                <Bar data={chartData} options={chartOptions} />
            </div>
        </div>
    );
};

export default BarMonthsStats;
